<template>
  <div class="contentPage">
    <div v-if="dispatchGraphData" class="statistics">
      <div class="statistics_title">Loads</div>
      <div class="statistics_top">
        <filter-item title="Select date"></filter-item>
        <filter-item title="Quantity weeks" isQuantity></filter-item>
      </div>
      <div class="statistics_graph">
        <div class="statistics_graph-wrap">
          <div class="statistics_graph-top">
            <dispatch-statistics-data
              :dispatchData="dispatchData"
            ></dispatch-statistics-data>
            <div class="right">
              <field
                width="100px"
                margin="0 0 0 10px"
                label-switch="Gross"
                :switch-value="isStackedA"
                @updateSwitch="onSwitch($event, 'isStackedA')"
                is-switch
                is-off-style
                is-dense
              ></field>
              <field
                width="100px"
                margin="0 0 0 10px"
                label-switch="RPM"
                :switch-value="isStackedB"
                @updateSwitch="onSwitch($event, 'isStackedB')"
                is-switch
                is-off-style
                is-dense
              ></field>
            </div>
          </div>
          <reactive-bar-chart
            class="trailers-chart"
            :chart-data="dispatchGraphData"
            :graph-a="isStackedA"
            :graph-b="isStackedB"
            :options="dispatchGraphOptions"
            :is-dark-theme="isDarkTheme"
          ></reactive-bar-chart>

<!--	        <reactive-bar-chart-new-->
<!--			        class="trailers-chart"-->
<!--			        :chart-data="dispatchGraphData"-->
<!--			        :graph-a="isStackedA"-->
<!--			        :graph-b="isStackedB"-->
<!--			        :options="dispatchGraphOptions"-->
<!--			        :is-dark-theme="isDarkTheme"-->
<!--	        ></reactive-bar-chart-new>-->
        </div>
        <trailer-charts
          v-once
          v-if="dispatchSpotRate"
          :data-rates="dispatchRate"
          :height="500"
        ></trailer-charts>
      </div>
      <main-table-all-back
          v-if="dispatchFilter"
          textCreate="create report"
          textReports="Reports"
          flag="dispatchStatistics"
          :headers="headers"
          :settings="getSettings"
          :filtersList="dispatchFilter"
          :list="dispatchList"
          :defaultOrder="dispatchOrder"
          :defaultSort="dispatchSort"
          :total-pages="dispatchTotal"
          :limit-pages="dispatchLimit"
          :exportStart="exportStart"
          :exportList="exportList"
          :uniqId="uniqId"
          @updateSettings="onSettingsOpen"
          @updateEvent="onEvent"
          @updateExportList="onExport"
          @updateList="onList"
          @updateRefreshFilters="onRefreshFilters"
          :isDispatchReports="isDispatchReports"
          is-create
          is-settings
      ></main-table-all-back>
<!--	    :preloaderFilters="getPreloader"-->
<!--	    :preloaderTotals="getPreloader"-->

    </div>
    <dispatch-statistics-reports
      v-if="isDispatchReports"
      :dispatchCustomers="dispatchCustomers"
      @updateDispatchReportsClose="onReportsClose"
    ></dispatch-statistics-reports>
    <table-settings
        v-if="isTableSettingsDrawer"
        @updateSettingsSave="onSettingsSave('statistics')"
        @updateSettingsCancel="onSettingsCancel"
        @updateSettingsClose="onSettingsClose"
        @updateSettingsAll="onSettingsAll"
        :settings="getSettings"
    ></table-settings>
    <preview-document v-if="previewLink"></preview-document>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import TrailerCharts from "@/components/Statistics/TrailerCharts/TrailerCharts";
import DispatchStatisticsData from "@/components/Statistics/DispatchStatistics/DispatchStatisticsData/DispatchStatisticsData";
import DispatchStatisticsReports from "@/components/Statistics/DispatchStatistics/DispatchStatisticsReports/DispatchStatisticsReports";
// shared
import ReactiveBarChart from "@/shared/chart/chart.js";
// import ReactiveBarChartNew from "@/shared/chart/ReactiveBarChart";
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack";
// constants
import FilterItem from "@/components/Statistics/DispatchStatistics/FilterItem/FilterItem";
import getUniqId from "@/helper/getUniqId";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import previewMixins from "@/mixins/previewMixins";

export default {
	name: "DispatchStatistics",
	mixins: [ settingsMixins, previewMixins ],
	components: {
		FilterItem,
		MainTableAllBack,
		TrailerCharts,
		ReactiveBarChart,
		// ReactiveBarChartNew,
		DispatchStatisticsData,
		DispatchStatisticsReports,
	},
	computed: {
		...mapGetters([
			"dispatchGraphOptions",
			"dispatchGraphData",
			"dispatchSpotRate",
			"dispatchRate",
			"dispatchData",
			"dispatchFilter",
			"dispatchList",
			"dispatchTotal",
			"dispatchLimit",
			"dispatchOrder",
			"dispatchSort",
			"getPreloader",
			"dispatchCustomers",
		]),
		isDarkTheme() {
			// если provide вернул функцию (наш случай) — вызываем её
			if (typeof this.themeIsDark === 'function') {
				return !!this.themeIsDark();
			}
			// если когда-то будет просто boolean — тоже приведём к Boolean
			return !!this.themeIsDark;
		},
	},
	data: () => ({
		isDispatchReports: null,
		isStackedA: true,
		isStackedB: true,
		exportStart: { id: 0, value: "All loads files" },
		exportList: [
			{ id: 2, value: "BOL" },
			{ id: 1, value: "Confirmation" },
			{ id: 3, value: "Other" },
			{ id: 4, value: "Loads (xlsx)" },
			{ id: 5, value: "Trips (xlsx)" },
			{ id: 0, value: "All loads files" },
		],
	}),
	methods: {
		...mapActions([
			"getDispatchStatistics",
			"getStatisticsRate",
			"getStatisticsFilter",
			"actionPreloader",
			"getStatisticsList",
			"getDispatchStatisticsReports",
			"onDispatchStatisticsExport",
			"onResetData",
		]),
		async onEvent(flag) {
			if (flag === "create") {
				this.actionPreloader(true);
				this.isDispatchReports = getUniqId();
			}

			if (flag === "reports") {
				await this.$router.push("/reports");
			}
		},
		async onExport(values) {
			await this.onDispatchStatisticsExport(values);
		},
		async onList(values) {
			this.actionPreloader(true);
			const { value, flag } = values;

			switch (flag) {
				case "sorting":
					await this.getStatisticsList(value);
					break;
				case "create":
					await this.getDispatchStatisticsReports(value);
					break;
				default:
					await Promise.all([
						this.getStatisticsFilter(value),
						this.getStatisticsList(value),
						this.getDispatchStatistics(value),
					]);
			}
			this.actionPreloader(false);
		},
		async onRefreshFilters() {
			this.actionPreloader(true);
			this.onResetData();
			await Promise.all([
				this.getStatisticsFilter(),
				this.getStatisticsList(),
				this.getDispatchStatistics({}),
			]);
			this.actionPreloader(false);
		},
		onReportsClose() {
			this.isDispatchReports = null;
		},
		onSwitch({ value }, key) {
			this[key] = value;
		},
	},
	async created() {
		this.actionPreloader(true);
		await Promise.all([
			this.getStatisticsFilter(),
			this.getStatisticsList(),
			this.getStatisticsRate(),
			this.getDispatchStatistics({}),
		]);
		this.actionPreloader(false);
	},
};
</script>

<style scoped lang="scss">
.statistics {
	margin: 0 45px;

	.filterItem {
		display: flex;
		align-items: center;

		&_text {
			color: var(--card-bg);
			text-align: right;
			font-size: 14px;
			font-style: normal;
			font-weight: 400;
			line-height: 20px;
		}
	}

	&_top {
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}

	&_title {
		font-size: 30px;
		font-weight: 500;
		line-height: 40px;
		letter-spacing: 0.25px;
		text-align: left;
		margin-bottom: 20px;
		color: var(--card-color);
	}

	&_graph {
		display: grid;
		grid-gap: 30px;
		grid-template-columns: 1fr 315px;
		align-items: start;

		&-top {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 20px;

			.right {
				display: flex;
				justify-content: flex-end;
				align-items: center;
				flex-grow: 1;
			}
		}

		&-wrap {
			background: var(--card-bg);
			width: 100%;
			padding: 30px 40px;
			height: 595px;
			border-radius: 5px;
			margin-bottom: 40px;
		}
	}
}

</style>
